<details class="trace-controls" open>
  <summary class="trace-controls__summary">
    <i class="pi pi-chevron-right trace-controls__chevron" aria-hidden="true"></i>
    Legend
  </summary>
  <div class="trace-controls__actions">
    <button type="button" class="iopoc-button small primary" (click)="toggle(true)">Select all</button>
    <button type="button" class="iopoc-button small primary" (click)="toggle(false)">Unselect all</button>
    <span role="status">{{ shownCount() }} of {{ traces().length }} traces shown</span>
  </div>
  <p class="trace-controls__description">Color identifies the well. Line style identifies the measurement: solid flow line, dashed casing head, dotted tubing, dash-dot well head.</p>
  <div class="trace-controls__scroll">
    <table aria-label="Trace visibility by well and measurement">
      <thead><tr><th scope="col">Well / measurement</th>
        @for (type of types(); track type) {
          <th scope="col"><label><input #column type="checkbox" [checked]="checked(undefined, type)"
            [indeterminate]="mixed(undefined, type)" [attr.aria-label]="'Toggle all ' + label(type) + ' traces'"
            (change)="toggle(column.checked, undefined, type)" />{{ label(type) }}</label></th>
        }
      </tr></thead>
      <tbody>
        @for (well of wells(); track well) {
          <tr><th scope="row"><label><input #row type="checkbox" [checked]="checked(well)" [indeterminate]="mixed(well)"
            [attr.aria-label]="'Toggle all ' + well + ' traces'" (change)="toggle(row.checked, well)" />
            <span class="trace-controls__well" [style.background-color]="matching(well)[0].color"></span>{{ well }}</label></th>
            @for (type of types(); track type) {
              <td>
                @if (matching(well, type).length) {
                  <label><input #cell type="checkbox" [checked]="checked(well, type)" [indeterminate]="mixed(well, type)"
                    [attr.aria-label]="well + ' ' + label(type)" (change)="toggle(cell.checked, well, type)" />
                    <svg class="trace-controls__sample" viewBox="0 0 40 12" aria-hidden="true">
                      <line x1="0" x2="40" y1="6" y2="6" [attr.stroke]="matching(well, type)[0].color"
                        stroke-width="3" [attr.stroke-dasharray]="matching(well, type)[0].borderDash?.join(' ')" />
                    </svg>
                  </label>
                } @else { <span>No data</span> }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</details>
@if (!shownCount()) { <p role="status">No traces selected. Use the matrix above to show measurements.</p> }
@for (graph of graphs(); track $index) {
  <app-reusable-chart [graph]="graph" [firstObservedAt]="period()?.onset ?? firstObservedAt()" [eventPeriod]="period()"
    [hiddenSeriesIds]="hidden()" [showLegend]="false" height="28.75rem" />
} @empty { <p role="status">No recorded measurements were supplied.</p> }
